import styled from 'styled-components'

export const StyledVolumesDatabaseTypeSelection = styled.div`
  display: flex;
  gap: 30px;
`
